import { render, staticRenderFns } from "./EditActionForm.vue?vue&type=template&id=6670b805&"
import script from "./EditActionForm.vue?vue&type=script&lang=ts&"
export * from "./EditActionForm.vue?vue&type=script&lang=ts&"
import style0 from "./EditActionForm.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports